import React, { useEffect } from "react";
import { observer } from "mobx-react";
import { Trans } from "react-i18next";
import classNames from "classnames";
import { Permissions } from "@whatsper/texterchat-common";
import { useStore } from "../../../../store/rootStore";
import { Operation } from "../../../EntityManager";
import { ManagerListView } from "../core";
import UserItemLabel from "../../../Base/Items/UserItem/UserItemLabel";
import styles from "./AgentsListView.module.scss";
const DepartmentsList = ({ entity, departments }) => {
    const getList = () => {
        if (departments) {
            return departments.filter((department) => { var _a; return (_a = department.agents) === null || _a === void 0 ? void 0 : _a.includes(entity.uid); });
        }
        return [];
    };
    return (React.createElement("div", { className: styles.userDepartment }, getList().map((department, i) => (React.createElement(UserItemLabel, { key: i, department: department })))));
};
const AgentTeaser = observer(({ entity }) => {
    const { departmentsStore } = useStore();
    return (React.createElement("div", { className: classNames(styles.teaserContainer, {
            [styles.disabled]: entity.disabled,
        }) },
        React.createElement("div", { className: styles.agentColor, style: { backgroundColor: entity.color || undefined } }),
        React.createElement("div", { className: styles.agentDetails },
            React.createElement("span", null, entity.displayName || entity.email || entity.uid),
            React.createElement(DepartmentsList, { entity: entity, departments: departmentsStore.departments }))));
});
const AgentsListView = ({ onEntitySelect, onEntityDelete, searchQuery = "", refreshList }) => {
    const { agentsStore } = useStore();
    useEffect(() => {
        refreshList === null || refreshList === void 0 ? void 0 : refreshList(agentsStore.fetchUsers);
    }, [refreshList]);
    const agentSearchQuery = searchQuery.trim().toLowerCase();
    const getOpSupported = () => {
        const { hasPermissions } = agentsStore;
        const ops = [];
        if (hasPermissions([Permissions.Permission.users_view])) {
            ops.push(Operation.LIST);
        }
        if (hasPermissions([Permissions.Permission.users_manage])) {
            ops.push(Operation.CREATE, Operation.EDIT);
        }
        return ops;
    };
    const sortAgents = (a, b) => {
        if (!a.temporary && !a.disabled && (b.temporary || b.disabled)) {
            return -1;
        }
        if (a.temporary && !a.disabled && b.disabled) {
            return -1;
        }
        return 1;
    };
    const filteredAgents = agentSearchQuery
        ? agentsStore.users.slice().filter((agent) => {
            var _a, _b, _c;
            const displayName = ((_a = agent.displayName) === null || _a === void 0 ? void 0 : _a.toLowerCase()) || "";
            const email = ((_b = agent.email) === null || _b === void 0 ? void 0 : _b.toLowerCase()) || "";
            const uid = ((_c = agent.uid) === null || _c === void 0 ? void 0 : _c.toLowerCase()) || "";
            return displayName.includes(agentSearchQuery) || email.includes(agentSearchQuery) || uid.includes(agentSearchQuery);
        })
        : agentsStore.users;
    return (React.createElement(ManagerListView, { entities: filteredAgents, entityIdKey: "_id", teaser: AgentTeaser, loading: agentsStore.loading, opSupported: getOpSupported(), onEntitySelect: onEntitySelect, onEntityDelete: onEntityDelete, createTitle: React.createElement(Trans, { i18nKey: "addAgent" }), sorter: sortAgents, readOnly: (entity) => !!entity.disabled }));
};
export default observer(AgentsListView);
